import { AnimatePresence, motion } from 'framer-motion'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import { useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { getVideo } from '@/api/center'
import playImg from '@/assets/images/play.png'
import ImgPlaceholder from '@/components/ImgPlaceholder'
import Loadding from '@/components/Loadding'
import Modal from '@/components/Modal'

export default function Index() {
  const [videoState, setVideoState] = useState(false)
  const [video, setVideo] = useState([])
  const [currentVideo, setCurrentVideo] = useState<string | null>(null)
  const [title, setTitle] = useState('')

  const play = (url: string, title: string) => {
    setVideoState(true)
    setTitle(title)
    setCurrentVideo(url)
  }

  const { isFetching, data } = useQuery(['getVideo'], getVideo)

  useEffect(() => {
    if (data && data.status === 0) {
      setVideo(data.data)
    }
  }, [data])

  return (
    <Container initial={{ opacity: 0, scale: 0.98 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.98 }} className=" relative">
      <Loadding state={isFetching}>
        <ul className=" m-0 p-0 list-none flex justify-between items-center">
          {video.map(({ imgurl, title, url }, i) => (
            <li key={i} onClick={() => play(url, title)}>
              <div className="guide cursor-pointer w-[223px] h-[125px] rounded overflow-hidden relative">
                <ImgPlaceholder className="guide-img w-full h-full rounded transition cursor-pointer duration-500" src={imgurl} alt="" />
                <div className="w-full h-full absolute top-0 left-0 flex justify-center items-center z-10">
                  <ImgPlaceholder className="w-[36px] h-[36px]" src={playImg} alt="" />
                </div>
              </div>
              <p className="p-0 mt-[10px] text-[14px] text-[#333]">{title}</p>
            </li>
          ))}
        </ul>
      </Loadding>
      <Modal show={videoState} title={title} cancel={() => setVideoState(false)} footer="" className="video-modal">
        {currentVideo ? <video id="video" autoPlay src={currentVideo} controls /> : null}
      </Modal>
    </Container>
  )
}

const Container = styled(motion.div)`
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  padding: 30px;
  background-color: #fff;
  border-radius: 6px;
  .guide:hover {
    .guide-img {
      transform: scale(1.1);
    }
  }
  .video-modal {
    width: 1000px;
    #video {
      width: 100%;
    }
  }
`
